import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketButton } from '@market/react';
import { useOrderDetails } from 'components/context/order_details';
import {
  onCheckoutPageClick,
  CHECKOUT_PAGE_CLICK_EVENTS,
} from 'components/pages/checkout/utilities';
import { COMPONENT_NAMES } from 'constants/tracking';

const SubmitButton = ({ disabled = false, buttonCTA, tokenize, onClick }) => {
  const { t } = useTranslation();

  const { trackingData } = useOrderDetails();

  const submitAction = async () => {
    onCheckoutPageClick({
      eventDesc: `${CHECKOUT_PAGE_CLICK_EVENTS.payment_form_submit} and Go to Review Order`,
      componentName: COMPONENT_NAMES.APPS.CHECKOUT.PAYMENT_INFO,
      additionalDetails: { button_text: t('checkout.label.reviewYourOrder') },
      actionItem: 'review_your_order',
      trackingData,
    });
    await tokenize();
  };

  return (
    <MarketButton
      {...(disabled && { disabled: true })}
      id="review-your-order-btn"
      rank="primary"
      onClick={async () => {
        onClick ? await onClick() : await submitAction();
      }}
      style={{ width: '100%' }}
    >
      {buttonCTA || t('common.submit')}
    </MarketButton>
  );
};

export default SubmitButton;
